// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Workflow.css */

.workflow-container {
  width: 80%;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f9f9f9;
  font-family: Arial, sans-serif;
  position: relative;
}

.step {
  margin-bottom: 20px;
}

.step h2 {
  margin-bottom: 15px;
  color: #333;
  font-size: 1.5em;
}

.step-upload input[type="file"] {
  margin-bottom: 10px;
}

button {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

button:hover:not(:disabled) {
  background-color: #0056b3;
}

.loading {
  margin-bottom: 10px;
  color: #007bff;
  font-weight: bold;
}

.error {
  color: red;
  margin-bottom: 10px;
  font-weight: bold;
}

.result-output {
  background-color: #f2f2f2;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  max-height: 300px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.step + .step {
  margin-top: 20px;
}

.workflow-container h2 {
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/workflow/docprocessing/document-processing.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB","sourcesContent":["/* Workflow.css */\n\n.workflow-container {\n  width: 80%;\n  margin: 20px auto;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n  font-family: Arial, sans-serif;\n  position: relative;\n}\n\n.step {\n  margin-bottom: 20px;\n}\n\n.step h2 {\n  margin-bottom: 15px;\n  color: #333;\n  font-size: 1.5em;\n}\n\n.step-upload input[type=\"file\"] {\n  margin-bottom: 10px;\n}\n\nbutton {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\nbutton:disabled {\n  background-color: #aaa;\n  cursor: not-allowed;\n}\n\nbutton:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.loading {\n  margin-bottom: 10px;\n  color: #007bff;\n  font-weight: bold;\n}\n\n.error {\n  color: red;\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.result-output {\n  background-color: #f2f2f2;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 15px;\n  max-height: 300px;\n  overflow-y: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.step + .step {\n  margin-top: 20px;\n}\n\n.workflow-container h2 {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
